import {
  type CustomActionForCallback,
  type CustomActionForCallbackData,
  type CustomActionForCallbackDataWithMetadata,
  customActionCallbackRequest,
} from '@iconik-io/shared-lib/src/redux/custom_actions/thunks';

import { METADATA_CUSTOM_ACTION_MODAL } from '../../constants/modals';
import type { AppDispatch } from '../../store/types';
import { segmentTrackEvent } from '../analytics_tracking/thunks';
import { successMessage } from '../messages/thunks';
import { openModal } from '../modals_manager/slice';

function redirectHttpLegacy(dispatch: AppDispatch, url: string) {
  const popupWindow = window.open(url, '_blank');
  try {
    // This raises an exception in Safari
    popupWindow?.focus();
  } catch (_e) {
    const action = successMessage({
      text: (
        <span>
          <a
            style={{
              color: 'var(--color-emphasis-high-emphasis-content)',
              textDecoration: 'underline',
            }}
            href={url}
            target="blank"
          >
            Click here to open the link
          </a>
        </span>
      ),
      timeout: 10000,
    });
    dispatch(action);
  }
}

export const triggerCustomActionLegacy =
  (
    action: CustomActionForCallback,
    data: CustomActionForCallbackDataWithMetadata,
  ) =>
  (dispatch: AppDispatch) =>
    dispatch(customActionCallbackRequest(action.context, action.id, data)).then(
      (response) => {
        const url = response.body.redirect_url;
        if (url) {
          if (/^https?:\/\//.test(url)) {
            redirectHttpLegacy(dispatch, url);
          } else {
            window.location.href = url;
          }
        } else {
          dispatch(successMessage({ text: `${action.label} triggered` }));
        }
      },
    );

export function customActionCallback(
  action: CustomActionForCallback,
  data: CustomActionForCallbackData,
) {
  return (dispatch: AppDispatch) => {
    if (action.metadataView) {
      dispatch(
        openModal({
          id: METADATA_CUSTOM_ACTION_MODAL,
          contextItems: [action],
          options: data,
        }),
      );
    } else {
      dispatch(triggerCustomActionLegacy(action, data)).then(() => {
        dispatch(
          segmentTrackEvent({
            eventName: 'Custom Action Triggered',
            properties: {
              Context: action.context,
              Type: action.type,
              'Metadata View': false,
            },
          }),
        );
      });
    }
  };
}
